import jLayerList from '@/views/layer/jLayerList';
import jLayerUpdate from '@/views/layer/jLayerUpdate';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/administrator/layer',
    name: 'jLayerList',
    component: jLayerList,
    meta: {
      title: 'Layer',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/administrator/layer/update/:id',
    name: 'jLayerUpdate',
    component: jLayerUpdate,
    meta: {
      title: 'Update Layer',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },

];



// WEBPACK FOOTER //
// ./src/router/jRouterLayer.js